// extracted by mini-css-extract-plugin
export default {"page":"Visit_page__yWYe8","button":"Visit_button__XI-hY","meetings":"Visit_meetings__qCMAe","title":"Visit_title__zE0d4","notify":"Visit_notify__76lDQ"};